"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M12.9983 5.01214L14.4957 3.51473C16.1497 1.86075 18.8313 1.86075 20.4853 3.51473V3.51473C22.1393 5.16872 22.1393 7.85036 20.4853 9.50434L15.494 14.4957C13.84 16.1497 11.1583 16.1497 9.50436 14.4957L9.00523 13.9966", stroke: "black", strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M11.0017 18.9879L9.50433 20.4853C7.85034 22.1393 5.1687 22.1393 3.51472 20.4853V20.4853C1.86073 18.8313 1.86073 16.1496 3.51472 14.4957L8.50606 9.50431C10.16 7.85033 12.8417 7.85033 14.4957 9.50432L14.9948 10.0034", stroke: "black", strokeWidth: "1", strokeLinecap: "round" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M17.3309 6.68282L19.3275 4.68628C21.5328 2.48097 25.1083 2.48097 27.3136 4.68628V4.68628C29.5189 6.89159 29.5189 10.4671 27.3136 12.6724L20.6585 19.3275C18.4532 21.5329 14.8777 21.5329 12.6724 19.3276L12.0068 18.662", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M14.6689 25.3172L12.6724 27.3137C10.4671 29.519 6.89156 29.519 4.68625 27.3137V27.3137C2.48093 25.1084 2.48094 21.5329 4.68625 19.3275L11.3414 12.6724C13.5467 10.4671 17.1222 10.4671 19.3275 12.6724L19.993 13.3379", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round" }, void 0)] }), void 0));
};
var LinkIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.LinkIcon = LinkIcon;
//# sourceMappingURL=LinkIcon.js.map